import { render, staticRenderFns } from "./callOldTotal.vue?vue&type=template&id=7f63bf5c&scoped=true&"
import script from "./callOldTotal.vue?vue&type=script&lang=js&"
export * from "./callOldTotal.vue?vue&type=script&lang=js&"
import style0 from "./callOldTotal.vue?vue&type=style&index=0&id=7f63bf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f63bf5c",
  null
  
)

export default component.exports